<template>
  <div id="MyAccount">
    <div class="nav-sub">
      <h4>My Account</h4>
      <ul>
        <li>
          <router-link :to="{name: 'AccountDetails'}">
            {{ getContentItem('accountDetailsMenu') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'UserSettings'}">
            {{ getContentItem('userSettings') }}
          </router-link>
        </li>
        <li>
          <a :href="urlMyPrivacy" target="_blank">
            {{ getContentItem('My Privacy') }}
          </a>
        </li>
        <li>
          <router-link :to="{name: 'AddressBookList'}">
            {{ getContentItem('addressBookMenu') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'WarehouseShippingOptions'}">
            {{ getContentItem('warehouseShippingOptionsMenu') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Orders' }">
            {{ getContentItem("ordersButton") }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    name: "MyAccount",
    data: () => ({
        urlMyPrivacy: ""
    }),
    computed: {
      ...mapGetters(["getContentItem"]),
    },
    created() {
      this.urlMyPrivacy = window.appGlobals.GLOBAL_LOGIN_MY_PRIVACY;
    },
  };
</script>
